import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../helpers/reducerRegistry'
import { handleDataTable } from '../helper'
import { getDistributionCreditRisk, getDistributionPerformance } from './thunk'

const initialState = {
  dataTable: [],
  dataTablePer: [],
  loading: true,
}

const slice = createSlice({
  name: 'portfolio/score/portfolioDistribution',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //getDistributionCreditRisk
    builder.addCase(getDistributionCreditRisk.pending, (state) => {
      state.loading = true
      state.dataTable = []
    })
    builder.addCase(
      getDistributionCreditRisk.fulfilled,
      (state, { payload = [] }) => {
        state.dataTable = handleDataTable(payload)
        state.loading = false
      },
    )
    builder.addCase(
      getDistributionCreditRisk.rejected,
      (state, { payload = [] }) => {
        state.loading = payload.loading
      },
    )

    //getDistributionPerformance
    builder.addCase(getDistributionPerformance.pending, (state) => {
      state.loading = true
      state.dataTable = []
    })
    builder.addCase(
      getDistributionPerformance.fulfilled,
      (state, { payload = [] }) => {
        state.dataTablePer = handleDataTable(payload)
        state.loading = false
      },
    )
    builder.addCase(
      getDistributionPerformance.rejected,
      (state, { payload = [] }) => {
        state.loading = payload.loading
      },
    )
  },
})

export const getDataTable = (state) => state[slice.name].dataTable
export const getDataTablePer = (state) => state[slice.name].dataTablePer
export const getLoading = (state) => state[slice.name].loading

register(slice.name, slice.reducer)
